import { fetchHandler } from "@/bapi-client/fetch";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";

export async function getTelematicsAssetHistory(
  customerId: string,
  equipmentId: string,
  start_ts: string,
  end_ts: string,
) {
  const response = await fetchHandler(
    BAPI_COMMANDS.TELEMATICS_GET_ASSET_HISTORY,
    "GET",
    `/telematics/${customerId}/events/${equipmentId}?page_size=3000&start_ts=${start_ts}&end_ts=${end_ts}`,
  );
  if (!response.success) return response;
  return await response.data.json();
}
